/**
 * .tuMetrics {"tu1": 0.95, "tu2": 0.9, "tu3": 1, "notes": "Map free-form status strings to CardStatus", "tuVersion": "2.5"}
 * .help "Agents and imports may send in_progress / In Progress; the board only keys off todo | inProgress | under_review | done | archived."
 */
import type { CardStatus } from '../types';

const CANONICAL: ReadonlySet<string> = new Set([
  'todo',
  'inProgress',
  'under_review',
  'done',
  'archived',
]);

/**
 * Coerce a free-form status (TeamBots intents, Google/GitHub webhooks, paste)
 * into the CardStatus the Flow board filters on. Unknown → null (caller keeps prior).
 */
export function normalizeCardStatus(raw: unknown): CardStatus | null {
  if (typeof raw !== 'string') return null;
  const trimmed = raw.trim();
  if (!trimmed) return null;
  if (CANONICAL.has(trimmed)) return trimmed as CardStatus;

  const key = trimmed.toLowerCase().replace(/[\s-]+/g, '_');
  switch (key) {
    case 'todo':
    case 'to_do':
    case 'backlog':
    case 'open':
      return 'todo';
    case 'inprogress':
    case 'in_progress':
    case 'progress':
    case 'doing':
    case 'started':
    case 'active':
      return 'inProgress';
    case 'under_review':
    case 'underreview':
    case 'review':
    case 'in_review':
    case 'pending_review':
      return 'under_review';
    case 'done':
    case 'complete':
    case 'completed':
    case 'closed':
    case 'finished':
      return 'done';
    case 'archived':
    case 'archive':
      return 'archived';
    default:
      return null;
  }
}
